import CountryRegionData from './CountryRegionData';

export const getRegionsForCountry = (country) => {
  if (!country) {
    return [];
  }

  let regions = [];
  CountryRegionData.forEach((i) => {
    if (i[0] === country) {
      regions = i;
    }
  });

  if (regions.length >= 3) {
    return regions[2].split('|').map((regionPair) => {
      const [regionName] = regionPair.split('~');
      return { regionName };
    });
  }

  return [];
}